import * as constants from '../state/constants/apiConstants'
import { axiosInstance } from './axiosInstance'

class OTPService {
	static async getKey(token) {
		const resp = await axiosInstance.get(constants.ACCOUNT_OTP_KEY, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: token,
			},
		})
		return resp.data
	}
}

export default OTPService
